import { render, staticRenderFns } from "./Encapsulation.vue?vue&type=template&id=3624684c&scoped=true"
import script from "./Encapsulation.vue?vue&type=script&lang=js"
export * from "./Encapsulation.vue?vue&type=script&lang=js"
import style0 from "./Encapsulation.vue?vue&type=style&index=0&id=3624684c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624684c",
  null
  
)

export default component.exports